import React, { useRef, useState } from "react";
import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const MegaMenu = ({ menuItem, menuTitle }) => {
  const menuLinkRef = useRef(null);
  const megaMenuRef = useRef(null);
  const [showMegaMenu, setShowMegaMenu] = useState(false);

  const handleProductHover = () => {
    setShowMegaMenu(true);
  };

  const handleProductLeave = () => {
    setShowMegaMenu(false);
  };

  return (
    <div className="mega-menu-container" onMouseEnter={handleProductHover} onMouseLeave={handleProductLeave}>
      <Nav.Link ref={menuLinkRef} className="product-link" style={{ cursor: "pointer" }}>
        {menuTitle}
      </Nav.Link>

      <div ref={megaMenuRef} className={`mega-menu ${showMegaMenu ? "show" : ""}`}>
        <div className="mega-menu-content">
          <div className="featured-section">
            {/* <h4>Featured Products</h4> */}
            {showMegaMenu && (
              <Swiper
                modules={[Navigation, Pagination]}
                spaceBetween={20}
                slidesPerView={6}
                navigation={true}
                // loop
                // pagination={{ clickable: true }}
                breakpoints={{
                  320: { slidesPerView: 1 },
                  768: { slidesPerView: 3 },
                  1024: { slidesPerView: 4 },
                  1200: { slidesPerView: 6 },
                }}
                className="products-swiper"
              >
                {menuItem.map((item) => (
                  <SwiperSlide key={item.id}>
                    <Link to={`${item.link}`} className="product-card">
                      <img
                        src={process.env.REACT_APP_IMAGE_BASE_URL + item?.image}
                        alt={item.name}
                        className="product-image"
                      />
                      <div className="product-info">
                        <h5>{item.name}</h5>
                        {/* <p>{item.description}</p> */}
                        {/* <button className="btn btn-primary btn-sm">View Details</button> */}
                      </div>
                    </Link>
                  </SwiperSlide>
                ))}
              </Swiper>
            )}

            <div className="swiper-button-prev"></div>
            <div className="swiper-button-next"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MegaMenu;
